import React, { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Header from '../src/comp/Component/Header'
import Footer from '../src/Component/Home/Footer'
import toast, { Toaster } from "react-hot-toast"
import fetchUserDetails from './comp/Utils/fetchUserDetail'
import { useDispatch } from 'react-redux'
import { setAllCategory } from './comp/Store/ProductSlice'
import { setUserDetails } from './comp/Store/Userslice'
import Axios from './comp/Utils/axios'
import SummaryAPI from './comp/Commson/summaryApi'
import "./App.css"

const App = () => {
  const dispatch = useDispatch()
  const location = useLocation() // ✅ IMPORTANT for pixel

  const fetchUser = async () => {
    const userData = await fetchUserDetails()
    if (userData) {
      dispatch(setUserDetails(userData))
    } else {
      console.warn("User data is empty")
    }
  }

  const fetchCategory = async () => {
    try {
      const response = await Axios({ ...SummaryAPI.getAllCategories })
      const { data: responseData } = response

      if (responseData.success) {
        dispatch(setAllCategory(responseData.data))
      }
    } catch (error) {
      console.error("Error fetching categories", error)
    }
  }

  // ✅ Initial data load
  useEffect(() => {
    fetchUser()
    fetchCategory()
  }, [])

  // ✅ META PIXEL PAGEVIEW ON ROUTE CHANGE
  useEffect(() => {
    if (window.fbq) {
      window.fbq('track', 'PageView')
    }
  }, [location.pathname])

  return (
    <div className="min-h-screen flex flex-col w-screen bg-white overflow-x-hidden">
      
      {/* Header */}
      <header className="w-screen max-w-[100vw] sticky top-0 z-50 bg-white shadow-md">
        <div className="w-full">
          <Header />
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 w-full">
        <div className="w-full max-w-full mx-auto">
          <Outlet />
        </div>
      </main>

      {/* Footer */}
      <footer className="w-screen max-w-[100vw] bg-gray-50 border-t border-gray-200 mt-auto">
        <div className="w-full">
          <Footer />
        </div>
      </footer>

      {/* Toast Notifications */}
      <div className="fixed z-[9999]">
        <Toaster />
      </div>
    </div>
  )
}

export default App
